import { render } from "./SafetyLenta.vue?vue&type=template&id=dc3aa39e&scoped=true"
import script from "./SafetyLenta.vue?vue&type=script&lang=js"
export * from "./SafetyLenta.vue?vue&type=script&lang=js"

import "./SafetyLenta.vue?vue&type=style&index=0&id=dc3aa39e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc3aa39e"]])

export default __exports__